import request from '../../../../api/request';
import { PaginationRequestType } from '../../../../types/paginationRequestType';

const SUBSIDIES = {
  BASE: '/maintainers-portal/admission-and-enrollments/subsidies',
  BY_ID: (id: number) =>
    `/maintainers-portal/admission-and-enrollments/subsidies/${id}`,
  TOGGLE: (id: number) =>
    `/maintainers-portal/admission-and-enrollments/subsidies/${id}/toggle-active`,
  PERIODS: '/maintainers-portal/admission-and-enrollments/subsidies/periods',
};

export interface SubsidyPeriod {
  id: number;
  name: string;
  code: string;
  startDate: string;
  endDate: string;
  academicYear: number | null;
}

export interface SubsidyPeriodAmount {
  periodId: number;
  amount: number;
  period?: {
    id: number;
    name: string;
    code: string;
    startDate: string;
    endDate: string;
  };
}

export interface Subsidy {
  id: number;
  name: string;
  code: string;
  isActive: boolean;
  applyAutomatically?: boolean;
  generalAmount?: number;
  periodAmounts?: SubsidyPeriodAmount[];
}

export interface CreateSubsidyData {
  name: string;
  code?: string;
  applyAutomatically: boolean;
  periodAmounts: { periodId: number; amount: number }[];
}

export type SubsidiesListResponse = PaginationRequestType<Subsidy>;

export const getSubsidiesRequest = (items: number = 10, page: number = 0) => {
  return request<SubsidiesListResponse>(SUBSIDIES.BASE, {
    params: { items_per_page: items, page },
  });
};

export const getSubsidyByIdRequest = (id: number) => {
  return request<Subsidy>(SUBSIDIES.BY_ID(id));
};

export const getPeriodsForSubsidyRequest = (yearFilter: string = 'last5') => {
  return request<SubsidyPeriod[]>(SUBSIDIES.PERIODS, {
    params: { yearFilter },
  });
};

export const createSubsidyRequest = (data: CreateSubsidyData) => {
  return request<Subsidy>(SUBSIDIES.BASE, {
    method: 'post',
    data,
  });
};

export const updateSubsidyRequest = (
  id: number,
  data: Partial<CreateSubsidyData>,
) => {
  return request<Subsidy>(SUBSIDIES.BY_ID(id), {
    method: 'put',
    data,
  });
};

export const toggleSubsidyActiveRequest = (id: number) => {
  return request<Subsidy>(SUBSIDIES.TOGGLE(id), {
    method: 'patch',
  });
};

export const deleteSubsidyRequest = (id: number) => {
  return request<void>(SUBSIDIES.BY_ID(id), {
    method: 'delete',
  });
};
